var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.97,
    height: 16.208,
    viewBox: "0 0 17.97 16.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-g-translate",
    "data-name": "Icon material-g-translate",
    d: "M19.173,5.431H10.979L10.188,3H4.8A1.721,1.721,0,0,0,3,4.621V15.156a1.721,1.721,0,0,0,1.8,1.621h6.289l.9,2.431h7.188a1.721,1.721,0,0,0,1.8-1.621V7.052A1.721,1.721,0,0,0,19.173,5.431ZM7.645,13.2A3.513,3.513,0,0,1,3.97,9.888,3.507,3.507,0,0,1,7.645,6.574a3.769,3.769,0,0,1,2.462.867l.063.049-1.105.956-.054-.041a2.066,2.066,0,0,0-1.366-.478A2.062,2.062,0,0,0,5.507,9.888a2.062,2.062,0,0,0,2.138,1.961,1.826,1.826,0,0,0,1.9-1.183H7.564V9.41h3.549l.009.057a2.3,2.3,0,0,1,.045.494A3.245,3.245,0,0,1,7.645,13.2Zm5.418-1.386a8.138,8.138,0,0,0,1.069,1.378l-.485.43Zm.692-.616h-.89l-.279-.843h3.585a6.051,6.051,0,0,1-1.4,2.22A7.423,7.423,0,0,1,13.755,11.2Zm6.316,6.386a.86.86,0,0,1-.9.81H12.883l1.8-1.621-.728-2.245.827-.746,2.408,2.18.656-.592L15.408,13.2a6.9,6.9,0,0,0,1.725-2.844h1.141V9.515H15V8.673h-.934v.843H12.308l-1.06-3.274h7.925a.86.86,0,0,1,.9.81Z",
    transform: "translate(-3 -3)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSet);
export default __webpack_public_path__ + "static/media/icon_set.ae701aa0e1a2e0625c5b1ca790c465d0.svg";
export { ForwardRef as ReactComponent };